import { ReactNode, useState } from 'react';

interface ButtonProps {
  icon?: string;
  iconRight?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant?: string;
  className?: string;
  children?: ReactNode;
  testId?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  icon,
  iconRight,
  children,
  onClick,
  variant = 'outlined',
  className,
  testId,
  disabled,
}) => {
  const [shouldRotateArrow, setShouldRotateArrow] = useState(false);
  const [rotating, setRotating] = useState(false);

  const handleClick = () => {
    setRotating(true);
    setTimeout(() => setRotating(false), 500);
  };

  return (
    <button
      data-pw={testId}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
        if (iconRight) {
          setShouldRotateArrow((prevState) => !prevState);
        }
      }}
      disabled={disabled}
      className={`custom_button ${variant} ${className}`}
    >
      {icon && <img src={icon} alt={icon} className={`icon ${rotating ? 'rotating' : ''}`} onClick={handleClick} />}
      {children ? <span className="button_value">{children}</span> : ''}
      {iconRight && (
        <img className={`arrow_icon ${!shouldRotateArrow ? 'rotated' : ''}`} src={iconRight} alt="iconRight"></img>
      )}
    </button>
  );
};
export default Button;
